var React = require('react');

function IconFacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.0498 7.53675H24.7914V3.03175C23.464 2.89766 22.1302 2.83146 20.7956 2.83342C16.8289 2.83342 14.1164 5.18508 14.1164 9.49175V13.2034H9.63934V18.2467H14.1164V31.1667H19.4831V18.2467H23.9456L24.6164 13.2034H19.4831V9.98758C19.4831 8.50008 19.8914 7.53675 22.0498 7.53675Z","fill":"white"}));
}

IconFacebookInline.defaultProps = {"width":"35","height":"34","viewBox":"0 0 35 34","fill":"none"};

module.exports = IconFacebookInline;

IconFacebookInline.default = IconFacebookInline;
